import { AxiosRequestConfig } from 'axios';
import { FarmaError } from 'src/integracoes/modelos/erros';

import axios from 'axios';
import { urlAPIPgLoader } from 'src/config';

export const pgLoaderApiClient = axios.create({
  baseURL: urlAPIPgLoader,
  headers: { 'Content-Type': 'application/json' }
});

async function request<T>(
  method: 'get' | 'post' | 'patch' | 'put' | 'delete',
  url: string,
  body?: any,
  config?: AxiosRequestConfig
): Promise<T> {
  const client = pgLoaderApiClient;
  try {
    const { data } = await client.request<T>({
      method,
      url,
      data: body,
      ...config
    });
    return data;
  } catch (err: any) {
    throw new FarmaError({
      nome: 'SCHEDULES_API_ERROR',
      mensagem:
        err?.response?.data?.mensagem ||
        err?.response?.data?.message ||
        'Erro ao consumir API de agendamentos',
      causa: err?.response?.data || err
    });
  }
}

// Métodos HTTP (usando request genérico)
export const get = <T>(url: string, config?: AxiosRequestConfig) =>
  request<T>('get', url, undefined, config);

export const post = <T>(url: string, body: any, config?: AxiosRequestConfig) =>
  request<T>('post', url, body, config);

export const patch = <T>(url: string, body: any, config?: AxiosRequestConfig) =>
  request<T>('patch', url, body, config);

export const put = <T>(url: string, body: any, config?: AxiosRequestConfig) =>
  request<T>('put', url, body, config);

export const del = <T>(url: string, config?: AxiosRequestConfig) =>
  request<T>('delete', url, undefined, config);
